import { resolveAssetUrl } from "../../services/apiConfig";
import { Link } from "react-router-dom";
import styles from "./FollowModal.module.css";
import Button from "../Button/Button";

function CommentModal({ isVisible, handleModal, users, heading, isLoading, error, composer }) {
  if (!isVisible) return null;

  const closeModal = () => {
    handleModal(false);
  };



  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContent}>
        <h1>{heading}</h1>
        {isLoading ? (
          <div className={styles.commentsLoading} role="status" aria-label="Carregando comentários">
            <span />
            <span />
            <span />
          </div>
        ) : error ? (
          <p className={styles.commentsError} role="alert">{error}</p>
        ) : users.length === 0 ? (
          <p>Ainda não há comentários.</p>
        ) : users.map((user, index) => {
          return (
            <div className={styles.commentedAccount} key={user.id ?? index}>
              <div className={styles.accountDetails}>
                <div className={styles.accountImage}>
                  <img
                    src={
                      user.user?.profile_url
                        ? resolveAssetUrl(user.user.profile_url)
                        : resolveAssetUrl("images/profile_image/user.png")
                    }
                    alt="Conta que comentou"
                  />
                </div>
                <Link to={`/profile/${user.user.username}`}>
                  <p className={styles.commentUsername}>{user.user.username}</p>
                </Link>
              </div>
              <p className={styles.commentDesc}>{user.comment}</p>
            </div>
          );
        })}
        {composer}
        {/* Close button */}
        <Button type="button" variant="secondary" fullWidth onClick={closeModal}>
          Fechar
        </Button>
      </div>
    </div>
  );
}

export { CommentModal };
